import "../../css/pages/insight.scss";

import BasePage from "./base";
import relatedInsights from "../modules/relatedInsights";
import accordion from "../modules/accordion";

class InsightPage extends BasePage {
    constructor(...opts) {
        super(...opts);
    }

    init() {
        super.init();
    }

    onReady() {
        super.onReady();
        relatedInsights.init();
        window.addEventListener("load", accordion.init);
    }
}

new InsightPage();
